import { generateURIWithQueryParams } from '@xmatters/redux/services/util';

/*
 * Send onboarding notification to all users who had a row in the upload
 */
export const IMPORT_SEND_NOTIFICATION = 'IMPORT_SEND_NOTIFICATION';
export const IMPORT_SEND_NOTIFICATION_SUCCESS = `${IMPORT_SEND_NOTIFICATION}_SUCCESS`;
export const IMPORT_SEND_NOTIFICATION_FAIL = `${IMPORT_SEND_NOTIFICATION}_FAIL`;

export const sendNotification =
  importJobId =>
  ({ subject, customMessage, signature }) => ({
    type: IMPORT_SEND_NOTIFICATION,
    meta: {
      xmApi: true,
      method: 'post',
      uri: `/webapi/xm/1/imports/${importJobId}/notify`,
      params: {
        subject,
        customMessage,
        signature,
      },
    },
  });

export const IMPORT_LOAD_IMPORTED_USERS = 'IMPORT_LOAD_IMPORTED_USERS';
export const IMPORT_LOAD_IMPORTED_USERS_SUCCESS = `${IMPORT_LOAD_IMPORTED_USERS}_SUCCESS`;
export const IMPORT_LOAD_IMPORTED_USERS_FAIL = `${IMPORT_LOAD_IMPORTED_USERS}_FAIL`;
export function loadWelcomeMessageTargets(importJobId) {
  return {
    type: IMPORT_LOAD_IMPORTED_USERS,
    meta: {
      xmApi: true,
      method: 'get',
      uri: `/webapi/xm/1/imports/${importJobId}/imported-users`,
    },
  };
}

export const IMPORT_LOAD_WELCOME_MESSAGES = 'IMPORT_LOAD_WELCOME_MESSAGES';
export const IMPORT_LOAD_WELCOME_MESSAGES_START = `${IMPORT_LOAD_WELCOME_MESSAGES}_START`;
export const IMPORT_LOAD_WELCOME_MESSAGES_SUCCESS = `${IMPORT_LOAD_WELCOME_MESSAGES}_SUCCESS`;
export const IMPORT_LOAD_WELCOME_MESSAGES_FAIL = `${IMPORT_LOAD_WELCOME_MESSAGES}_FAIL`;

// TODO Remove the "User Upload" plan and form after plan/form names have been updated
export const onboardingPlanName =
  'User Onboarding Notifications, User Upload Onboarding Notifications';
export const onboardingFormName = 'Welcome Aboard, User Upload: Welcome Aboard';
export const loadWelcomeMessages = importJobId => ({
  type: IMPORT_LOAD_WELCOME_MESSAGES,
  meta: {
    xmApi: true,
    method: 'get',
    uri: '/webapi/xm/1/events',
    params: {
      propertyName: ['importId#en'],
      propertyValue: [importJobId],
      embed: 'properties',
      plan: onboardingPlanName,
      form: onboardingFormName,
    },
    customUriWithParamsGenerator: generateURIWithQueryParams,
  },
});

/*
 * Local UI state (non-API):
 */
export const IMPORT_OPEN_ONBOARDING_SEND_MODAL =
  'IMPORT_OPEN_ONBOARDING_SEND_MODAL';

export const openOnboardingSendModal = (messageType = 'DEFAULT') => ({
  type: IMPORT_OPEN_ONBOARDING_SEND_MODAL,
  payload: { messageType },
});
